import cx from "clsx";
import { Artwork } from "kreate-common/modules/business-types";
import ButtonTransparentV2 from "kreate-common/modules/kreate-ui/components/ButtonTransparentV2";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";
import {
  MdChat,
  MdFavorite,
  MdFavoriteBorder,
  MdPeopleAlt,
} from "react-icons/md";

import CollectionTwoLineViewer from "../../components/CollectionTwoLineViewer";
import { useArtworkLover } from "../../hooks/useArtworkLover";

import styles from "./index.module.scss";

import Format from "@/modules/kreate-components/components/Format";
import { useModalTrigger$ModalCollectorListViewer } from "@/modules/kreate-modals/modals/ModalCollectorListViewer/hooks";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  artwork: Artwork;
  onScrollToTabComments?: () => void;
};

export default function ArtworkInfoViewer({
  className,
  style,
  artwork,
  onScrollToTabComments,
}: Props) {
  const modalTriggers = {
    ModalCollectorListViewer: useModalTrigger$ModalCollectorListViewer(),
  };

  const artworkLover = useArtworkLover(artwork);

  return (
    <div className={cx(styles.container, className)} style={style}>
      {artwork ? (
        <Flex.Row
          flex="0 1 auto"
          minWidth="0"
          gap="20px"
          justifyContent="space-between"
        >
          {artwork ? (
            <Flex.Cell asChild minWidth="0" flex="0 1 auto">
              <CollectionTwoLineViewer artwork={artwork} />
            </Flex.Cell>
          ) : undefined}
          <Flex.Row gap="20px" minWidth="0" flex="0 0 auto">
            <Flex.VerticalDivider
              className={styles.colorFgDivider}
              borderStyle="dashed"
            />
            <Flex.Row gap="20px">
              <ButtonTransparentV2
                icon={<MdPeopleAlt size="20px" />}
                onClick={async () =>
                  await modalTriggers.ModalCollectorListViewer.openModal({
                    artworkId: artwork.artworkId,
                  })
                }
              >
                <Format.Integer
                  className={styles.textTransform_none}
                  integer={artwork.numCollectors}
                  unstyled
                />
              </ButtonTransparentV2>
              <Flex.Row flex="0 0 auto" alignItems="center" gap="8px">
                <ButtonTransparentV2
                  icon={
                    artworkLover.isLoved ? (
                      <MdFavorite
                        className={styles.colorFgPrimary}
                        size="20px"
                      />
                    ) : (
                      <MdFavoriteBorder size="20px" />
                    )
                  }
                  disabled={artworkLover.busy}
                  onClick={artworkLover.toggleLove}
                />
                <Format.Integer
                  className={styles.fontSize14px}
                  integer={artworkLover.numLovers}
                  unstyled
                />
              </Flex.Row>
              <ButtonTransparentV2
                icon={<MdChat size="20px" />}
                onClick={() => onScrollToTabComments?.()}
              >
                <Format.Integer
                  className={styles.textTransform_none}
                  integer={artwork.totalNumComments}
                  unstyled
                />
              </ButtonTransparentV2>
            </Flex.Row>
          </Flex.Row>
        </Flex.Row>
      ) : undefined}
    </div>
  );
}
